"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const mui_1 = require("tss-react/mui");
exports.useStyles = (0, mui_1.makeStyles)()(theme => ({
    fieldDescription: {
        '&:hover': {
            background: theme.palette.mode === 'dark' ? '#e65100' : 'yellow',
        },
    },
    fieldName: {
        wordBreak: 'break-all',
        minWidth: 90,
        borderBottom: '1px solid #0003',
        fontSize: 12,
        background: theme.palette.action.disabledBackground,
        marginRight: theme.spacing(1),
        padding: theme.spacing(0.5),
    },
}));
function FieldName({ description, name, width, prefix = [], }) {
    const { classes, cx } = (0, exports.useStyles)();
    const val = [...prefix, name].join('.');
    return description ? (react_1.default.createElement(material_1.Tooltip, { title: description, placement: "left" },
        react_1.default.createElement("div", { className: cx(classes.fieldDescription, classes.fieldName) }, val))) : (react_1.default.createElement("div", { className: classes.fieldName, style: { width: width } }, val));
}
exports.default = FieldName;
